<template>
  <el-row :gutter="12" id="contact">
    <el-card shadow="hover">
      <el-col :span="24">
        阿金的邮箱：<a href="mailto:disciple_sneaker@163.com">disciple_sneaker@163.com</a>
      </el-col>
    </el-card>
  </el-row>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style scoped>
  .el-col{
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue